module.exports = __webpack_public_path__ + "static/startupstory-401844493d71e75f13e3355860b1707c.png";